import { map, orderBy, paths, pipe } from 'lodash/fp'

import { toOption } from '@/shared/tools/utils'

export const transformToOptions = pipe(
	orderBy(['is_main'], ['desc']),
	map(paths(['id', 'name'])),
	toOption
)
